import { Fragment, memo } from 'react';
import cls from 'classnames';

import styles from './Title.module.scss';

interface TitleProps {
  isCutGrade: boolean;
  isCut: boolean;
}

function Title({ isCutGrade, isCut }: TitleProps) {
  return (
    <div className="container">
      <div className={cls(styles.root)}>
        {!isCutGrade && !isCut && <div className={styles.withFirstLetter}>DiLog</div>}

        {isCutGrade && (
          <Fragment>
            <div className={styles.withFirstLetter}>CutGrade</div>

            <div>
              &&nbsp;<div className={styles.withFirstLetter}>DiLog</div>
            </div>
          </Fragment>
        )}

        {isCut && (
          <div className={styles.row}>
            <div className={styles.withFirstLetter}>DiLog</div>

            <div className={styles.withFirstLetter}>Cut</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default memo(Title);
